export default __webpack_public_path__ + "static/media/sandbox2.188442f0.png";